import type { MemberAccessRule } from './types.js';

export const ECMA_SCRIPT_MEMBER_ACCESS_RULES: MemberAccessRule[] = [
  { parentType: 'member_expression', objectField: 'object', propertyField: 'property', tagKind: 'member' },
];

export const JAVASCRIPT_MEMBER_ACCESS_RULES = ECMA_SCRIPT_MEMBER_ACCESS_RULES;
export const TYPESCRIPT_MEMBER_ACCESS_RULES = ECMA_SCRIPT_MEMBER_ACCESS_RULES;
export const TSX_MEMBER_ACCESS_RULES = ECMA_SCRIPT_MEMBER_ACCESS_RULES;
